import React, { useState, useEffect } from 'react'
import { Row, ControlLabel, Uploader, Icon, Message } from 'rsuite'
import AttachFilesWidget from './AttachFilesWidget'
import InputForm from '../../components/forms/input/InputForm'
import classNames from 'classnames'
import { isEmpty } from 'lodash-es'
import AppContext from '../../context/AppContext'
import {
  isValidators,
  isRequired,
  getMaxLengthData,
  requiredFiled,
} from '../../utils/ValidatorUtils'

export default function ProjectEvaluationWidget({
  schema: _schema,
  attachmentSchema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const { theme } = React.useContext(AppContext)

  return (
    <>
      {schema.note && (
        <Row>
          <InputForm
            schema={schema.note}
            rows={3}
            componentClass="textarea"
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </Row>
      )}

      <br />

      {attachmentSchema && (
        <Row>
          <ControlLabel
            className={classNames(
              'style-text-lable'
              // isRequired(attachmentSchema.validators) && 'required'
            )}
          >
            {attachmentSchema.label}
          </ControlLabel>
          {/* <ErrorMessage error={errors.attachment} /> */}
          <Message
            style={{ marginTop: 10, marginBottom: 10 }}
            closable
            onClose={() => {
              setFileTypeError(false)
            }}
            showIcon
            type="info"
            description="ชนิดที่รองรับ : .jpg, .doc, .docx, .jpeg, .png,  ขนาดไฟล์ไม่เกิน 50 MB"
          />
          <Controller
            name={'attachment'}
            control={control}
            defaultValue={!isEmpty(attachmentSchema.value) ? [attachmentSchema.value] : undefined}
            // rules={isValidators(attachmentSchema.validators)}
            render={(props) => {
              return (
                <Uploader
                  draggable
                  autoUpload={false}
                  fileList={props.value || []}
                  onChange={(fileList) => {
                    if (isEmpty(fileList)) {
                      props.onChange(undefined)
                    } else {
                      let files = []
                      files.push(fileList[fileList.length - 1])
                      props.onChange(files)
                    }
                  }}
                >
                  <div>
                    <br />
                    <div className={classNames('uploader', `${theme[0]}-background`)}>
                      <Icon size="4x" icon="upload2" />
                      <br />
                      <br />
                      <small className="uploder__text">
                        <p style={{ wordBreak: 'break-word' }}>
                          คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                        </p>
                      </small>
                    </div>
                    <br />
                  </div>
                </Uploader>
              )
            }}
          />
        </Row>
      )}
    </>
  )
}
